import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h5" sx={{ mb: 1.25, fontWeight: 700 }}>
      {title}
    </Typography>
    {children}
  </Box>
);

const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
      <Paper elevation={2} sx={{ p: { xs: 2.5, md: 5 }, borderRadius: 2 }}>
        <Typography variant="h3" sx={{ mb: 2, fontWeight: 800 }}>
          Terms and Conditions
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Effective Date: 19/04/2026
        </Typography>

        <Box sx={{ p: 2, mb: 3, borderLeft: '4px solid #00BCD4', bgcolor: 'background.default', borderRadius: 1 }}>
          <Typography sx={{ mb: 1 }}>
            <strong>AdaptPrepare</strong> is designed to support regular practice, improve
            accuracy and confidence, and complement school learning.
          </Typography>
          <Typography>
            <strong>AdaptPrepare does not replace teaching, tutoring, or formal examinations.</strong>
          </Typography>
        </Box>

        <Section title="1. Purpose of the Platform">
          <Typography>
            AdaptPrepare is designed to support regular practice, improve accuracy and
            confidence, and complement school learning. AdaptPrepare does not replace
            teaching, tutoring, or formal examinations.
          </Typography>
        </Section>

        <Section title="2. Eligibility and sign-up">
          <Typography>
            You must be <strong>18 years of age or older</strong> to create an account and use
            AdaptPrepare. By registering, you confirm that you meet this minimum age
            requirement.
          </Typography>
        </Section>

        <Section title="3. Referral Program Participation">
          <Typography>
            By signing up for AdaptPrepare, you are also enrolled in our referral program.
            Participation is subject to applicable referral eligibility criteria and program rules.
          </Typography>
        </Section>

        <Section title="4. User Roles">
          <Typography sx={{ fontWeight: 600, mb: 1 }}>Students</Typography>
          <Typography component="ul" sx={{ pl: 3, mb: 2 }}>
            <li>Use the platform for practice only</li>
            <li>Are not ranked or compared with other students</li>
          </Typography>
          <Typography sx={{ fontWeight: 600, mb: 1 }}>Parents / Teachers</Typography>
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>Create and assign practice sets</li>
            <li>Monitor progress responsibly</li>
            <li>Use insights to support learning, not pressure performance</li>
          </Typography>
        </Section>

        <Section title="5. Acceptable Use">
          <Typography sx={{ mb: 1 }}>Users agree not to:</Typography>
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>Misuse or manipulate results</li>
            <li>Upload inappropriate content</li>
            <li>Attempt to access other users&apos; data</li>
            <li>Use the platform for competitive ranking or public comparison</li>
          </Typography>
        </Section>

        <Section title="6. Assessments & Practice Disclaimer">
          <Box sx={{ p: 2, borderLeft: '4px solid #FF9800', bgcolor: 'background.default', borderRadius: 1 }}>
            <Typography component="ul" sx={{ pl: 3 }}>
              <li>Scores and feedback are indicative, not diagnostic.</li>
              <li>Performance may vary across contexts.</li>
              <li>Improvement depends on consistency and learning support.</li>
            </Typography>
          </Box>
        </Section>

        <Section title="7. AI Disclaimer">
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>
              AI-generated content (including questions, feedback, and analysis) may
              contain inaccuracies, omissions, or unintended output.
            </li>
            <li>
              AI outputs are intended to support understanding and do not replace
              teacher guidance or independent review.
            </li>
            <li>
              Users should verify AI content before relying on it for important
              academic decisions.
            </li>
            <li>
              If you identify an issue, please report it to us so we can improve the
              platform.
            </li>
          </Typography>
        </Section>

        <Section title="8. Account Responsibility">
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>Users are responsible for maintaining account security.</li>
            <li>AdaptPrepare is not liable for misuse due to shared credentials.</li>
          </Typography>
        </Section>

        <Section title="9. Support and Service Levels">
          <Typography sx={{ mb: 1 }}>
            Support is provided on a <strong>best-effort basis</strong>.
          </Typography>
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>Response and resolution times are not guaranteed.</li>
            <li>
              Any specific service-level commitments apply only if agreed separately in
              writing.
            </li>
          </Typography>
        </Section>

        <Section title="10. Limitation of Liability">
          <Typography sx={{ mb: 1 }}>AdaptPrepare is provided &quot;as is&quot;. We are not responsible for:</Typography>
          <Typography component="ul" sx={{ pl: 3 }}>
            <li>Exam outcomes</li>
            <li>Academic decisions</li>
            <li>External evaluations</li>
          </Typography>
        </Section>

        <Section title="11. Termination">
          <Typography>
            We reserve the right to suspend or terminate accounts that violate these terms
            or misuse the platform.
          </Typography>
        </Section>

        <Section title="12. Governing Law">
          <Typography>These terms are governed by the laws of India.</Typography>
        </Section>

        <Box sx={{ p: 2, borderLeft: '4px solid #00BCD4', bgcolor: 'background.default', borderRadius: 1 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
            13. Contact
          </Typography>
          <Typography>support@adaptprepare.ai</Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsAndConditions;
